module.exports = __webpack_public_path__ + "img/ziying.eb031bc5.png";